import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { SavedList } from '~/clientApi/savedLists.model';
import { ICreator } from '~/types';

import { ListCreatorDropdownMenu } from './ListCreatorDropdownMenu/ListCreatorDropdownMenu';

interface CreatorButtonsProps {
  list: SavedList;
  creator: ICreator;
  isShared: boolean | undefined;
  note?: string;
  onNoteOpen?: () => void;
}

export function CreatorButtons({
  list,
  creator,
  isShared,
  note,
  onNoteOpen,
}: CreatorButtonsProps) {
  return (
    <Flex justify="wrap" alignItems="center">
      <Box marginRight="auto">
        {!isShared ? (
          <ListCreatorDropdownMenu
            list={list}
            creator={creator}
            note={note}
            onNoteOpen={onNoteOpen}
            isShared={isShared}
          />
        ) : null}
      </Box>
    </Flex>
  );
}
